export {default} from './NewFrontlineClientsReport';
